import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsTreasure: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.525 13.72v13.71h1.52V15.24h19.81v12.19H3.045v1.52h25.91v-1.52h-4.57V15.24h4.57v12.19h1.52V7.62h-1.52v4.57h-1.53v1.53H7.615v-1.53h-1.52v1.53zm25.9-7.62h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M25.905 16.76h1.52v9.15h-1.52Zm0-6.09h1.52v1.52h-1.52Zm0-6.1h1.52V6.1h-1.52Zm-1.52 4.57h1.52v1.53h-1.52Zm0-3.04h1.52v1.52h-1.52Zm-10.67 13.71h-1.53v6.1h7.62v-9.15h-6.09Zm4.57 1.52v3.05h-4.57v-3.05Zm-7.62-4.57h1.52v1.53h-1.52Zm-1.52 0h-4.57v9.15h6.09v-6.1h-1.52Zm0 7.62H6.1v-3.05h3.05ZM4.575 3.05h21.33v1.52H4.575Zm0 7.62h1.52v1.52h-1.52Zm19.81-1.53V7.62H3.045V6.1h-1.52v3.04h1.52v1.53h1.53V9.14zM3.045 4.57h1.53V6.1h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsTreasure
